//import ADDITIONAL_PRACTICE from "../assets/additional_practice_icon.svg";
import I_DO from "../assets/i_do_icon.svg";
import YOU_DO from "../assets/you_do_icon.svg";
import WE_DO from "../assets/we_do_icon.svg";
import HOMEWORK from "../assets/homework_icon.svg";
import LI_LO from "../assets/li_lo_icon.svg";
import CHECKED_ICON from "../assets/checked_icon.svg";
import CONCLUSION from "../assets/conclusion.svg";
import CONCEPT_TIME from "../assets/concept-time.svg";
import CIRCLE_TIME from "../assets/circle-time.svg";
import PRACTICE_TIME from "../assets/practice-time.svg";
import WRITING_TIME from "../assets/write-time.svg";
// import CONVERSATION_TIME from "../assets/conversation-time.svg";
import HOME_PRACTICE from "../assets/home-practice.svg";

export const TYPES = {
  LEARNING_INDICATOR: "LEARNING_INDICATOR",
  UNORDERED_LIST: "UNORDERED_LIST",
  ICON: "ICON",
  ORDERED_LIST_ALPHA: "ORDERED_LIST_ALPHA",
  PDF: "PDF",
  VIDEO: "VIDEO",
  PARAGRAPH: "PARAGRAPH",
  HEADING: "HEADING",
};

//PINNACLE
//Class 2
export const PINNACLE_EVS_DAY1_CH5 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Expanded Universal EVS G2 book and turn to Chapter 5, page 40-41",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li><strong>Learning outcome: </strong>Identify the bones and muscles in our body.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Introduce bones and muscles using a video.",
    icon: I_DO,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "To build interest in the topic, you can conduct the Stepping Stones activity on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/SB-1-Pg.%2040.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 40",
            timeTakenToComplete: "",
          },
          {
            text: "To explain the importance of bones and muscles, you can use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/CRL-1-How%20My%20Body%20Works.mp4",
            mediaType: TYPES.VIDEO,
            icon: "",
            mediaName: "How My Body Works",
            timeTakenToComplete: "3:29",
          },
          {
            text: "To explain the functions of the skull and ribcage, you can read and discuss the first three paragraphs of the section on ‘Bones’ on the following pages:",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/SB-1-Pg.%2040.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 40",
            timeTakenToComplete: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/SB-2-Pg.%2041.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 41",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Students independently answer a question from the textbook for conceptual clarity.",
    icon: YOU_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "To summarize the learning, you can ask students to locate their skulls and ribs by pointing toward them.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Students can then answer Q D(1) on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/SB-8-Pg.%2047.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 47",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, you can refer to",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%201/SolvedSB-1-Answer%20Key.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Answer Key",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "Practice questions involving the conversion of fractions.",
    icon: HOMEWORK,
    timeTakenToComplete: "15 mins",
    render: `<ul><li>Find out the name of the largest bone in your body.</li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_EVS_DAY4_CH5 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Expanded Universal EVS G2 book and turn to Chapter 5, page 44",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li><strong>Learning outcome: </strong>Explain how correct posture keeps our body healthy.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Explain the importance of correct posture through a video.",
    icon: I_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To explain the importance of correct posture, you can use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%204/CRL-5-Posture.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Posture",
            icon: "",
            timeTakenToComplete: "0:52",
          },
          {
            text: "You can then read and explain the section ‘Posture’ on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%204/SB-5-Pg.%2044.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 44",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading: "Students independently solve a question on posture.",
    icon: YOU_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Students can now independently solve Q D(3) on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%204/SB-8-Pg.%2047.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 47",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, you can refer to",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/EVS/Day%204/SolvedSB-1-Answer%20Key.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Answer Key",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading:
      "Students work in groups to demonstrate the correct posture for doing different activities.",
    icon: WE_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Divide the students into three groups.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Each group of students can then demonstrate the correct and incorrect postures while sitting, standing, and picking up their bags from the ground, respectively.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
];

export const PINNACLE_MATHS_DAY3_CH2 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Math Ace Prime G2 book and turn to Chapter 2, page 19-20",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li><strong>Learning outcome: </strong>Add 2-digit numbers without or with regrouping.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading:
      "Explain the steps to add 2-digit numbers with regrouping using a video.",
    icon: I_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To explain the steps to add 2-digit numbers with regrouping, you can play",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/CRL-2-Addition%20of%202%20Digit%20Numbers%20by%20Regrouping.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Addition of 2 Digit Numbers by Regrouping",
            icon: "",
            timeTakenToComplete: "4:58",
          },
          {
            text: "To reinforce the steps of adding 2-digit numbers using the column method, you may discuss Example 2 given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/SB-5-Pg%2019.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg 19",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "You may ask relevant questions to deduce and explain the teacher tip given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/SB-5-Pg%2019.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg 19",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Practice questions involving the addition of 2-digit numbers with regrouping",
    icon: YOU_DO,
    timeTakenToComplete: "20 mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Students can now independently solve the part (a) and (b) of Exercise 2C given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/SB-7-Pg%2020.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 20",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/WS-3-Worksheet%203.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Worksheet 3",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "As an example, you may solve Q 1 (a) of Worksheet 3 on the board.",
            media: "",
            mediaType: "",
            mediaName: "",
            type: TYPES.UNORDERED_LIST,
            icon: "",
            dataList: [],
          },
          {
            text: "To check answers during notebook correction, you can use ",
            type: TYPES.UNORDERED_LIST,
            dataList: [],
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/TR-5-Solutions%20to%20Practice%20Questions.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solutions to Practice Questions",
            icon: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/WS-3-Worksheet%203.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Worksheet 3",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "As an example, you may solve Q 1 (a) of Worksheet 3 on the board.",
            media: "",
            mediaType: "",
            mediaName: "",
            type: TYPES.UNORDERED_LIST,
            icon: "",
            dataList: [],
          },
          {
            text: "To check answers during notebook correction, you can use ",
            type: TYPES.UNORDERED_LIST,
            dataList: [],
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/Maths/Day%203/TR-5-Solutions%20to%20Practice%20Questions.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solutions to Practice Questions",
            icon: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "Practice questions involving the conversion of fractions.",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul><li>Solve parts (c to e) of Exercise 2C given on Pg. 20</li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_ENGLISH_DAY2_CH3 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Revised Celebrate book and turn to Chapter 3, page 15, 16",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<div>Comprehend the story and answer questions related to the story</div>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "",
    icon: I_DO,
    timeTakenToComplete: "25 mins",
    dataList: [
      {
        text: "Introduce and read the story.",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "You can show the animation of The King of the Jungle by using",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/English/Day%202/CRL-2-The%20King%20of%20the%20Jungle%20Animation.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "The King of The Jungle Animation",
            icon: "",
            timeTakenToComplete: "02:01",
          },
          {
            text: "You can pause to ask comprehension and pronunciation questions as you read the story on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class2/English/Day%202/SB-3-Pg.%2015-16.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 15-16",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading: "",
    icon: WE_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "Students can answer questions on the reading. Some sample questions are listed below:",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "What is the title of the story? (The King of the Jungle)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "What is the setting, or the place where the story happens? (The Jungle)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Who are the two characters in the story? (The lion and the rabbit)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "What questions do you have about the story? (Take responses)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "Practice questions involving the conversion of fractions.",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul>
    <li>Skim through the reading and circle words you cannot pronounce on Pg. 15-16 of Chapter 3.</li>
    <li>We will review these words in the next class.</li>
    <li>Practice for the spelling test (vocabulary words) on Day 5. (mighty, hopping, idea, bowed, majesty, clever)</li>
    </ul>`,
    dataList: [],
  },
];

//Class5
export const PINNACLE_MATHS_DAY1_CH4 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Math Ace Prime book and turn to Chapter 4, page 68-70",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li><strong>Learning outcome: </strong>Discuss some basic facts about fractions.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Recap the concept of parts and whole through an activity.",
    icon: I_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To recap the concept of parts and whole, use the Tune up activity given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Maths/Day%201/SB-2-Pg.%2068.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 68",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading: "Group activity to visualise different types of fractions.",
    icon: WE_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To facilitate the group activity on visualising different types of fractions, use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Maths/Day%201/CRL-1-Chapter%20Overview.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Chapter Overview",
            icon: "",
            timeTakenToComplete: "1:00",
          },
          {
            text: "Alternatively, you may conduct this activity by asking students to draw the fractional representations in their notebooks.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Practise questions involving the conversion of fractions from one type to another.",
    icon: YOU_DO,
    timeTakenToComplete: "10 mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Students can now independently solve Q 1 (a, b) and Q 2 (a, b) of Exercise 4.1 given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Maths/Day%201/SB-3-Pg.%2070.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 70",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, you can use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Maths/Day%201/TR-1-Solutions%20to%20Practice%20Questions.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solutions to Practice Questions",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul><li>Solve Q 1 (c, d, e) and Q 2 (c, d, e) of Exercise 4.1 given on Pg. 70.</li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_SCIENCE_DAY2_CH4 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Expanded Universal Science book and turn to Chapter 4, page 45",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li><strong>Learning Outcome:</strong> Describe the functions of the nervous system.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Explain the different parts of the brain using a video.",
    icon: I_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "To teach the different parts of the brain, you can show",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Science/Day%202/CRL-5-C5Ch2-Parts-of-the-Brain.mp4",
            mediaType: TYPES.VIDEO,
            icon: "",
            mediaName: "Parts of the Brain",
            timeTakenToComplete: "1:15",
          },
          {
            text: "To reinforce the concept, you can get students to read the following page along with you:",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Science/Day%202/SB-2-C5Ch4.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 45",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading:
      "Students create models of the brain to understand its functions.",
    icon: WE_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "To conduct the activity, distribute clay to the students.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
          {
            text: "Students can observe the structure of the brain in the textbook and use their creativity to build their own clay models.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Students independently solve questions related to the structure and function of the brain.",
    icon: YOU_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Students can now independently solve Q 1 on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Science/Day%202/SB-5-C5Ch4.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 48-49",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "They can then solve Q C(6) given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Science/Day%202/SB-10-C5Ch4.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 53",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, you can refer to",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/Science/Day%202/SolvedSB-1-C5Ch4.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Answer Key",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    render: `<ul><li>Answer Q C(1) and (3), Q D7(a), and Q D(8) on <strong>Pg.No. 53.</strong></li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_ENGLISH_DAY1_CH4 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Revised Celebrate Class 5 book and turn to Chapter 4, page 35, 36, 40",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "I Do",
    subHeading: "Introduce The Story of Louis Braille.",
    icon: I_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "Build curiosity in students by introducing and discussing the meaning of the fixed expression:",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
            dataList: [
              {
                text: "Today it was raining cats and dogs and the streets were flooded.",
                media: "",
                mediaType: "",
                icon: "",
                mediaName: "",
                timeTakenToComplete: "",
              },
            ],
          },
          {
            text: "Build interest in fixed expressions by discussing their creative value using the examples on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/SB-40-Pg.%2040.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 40",
            timeTakenToComplete: "",
          },
          {
            text: "You can introduce The Story of Louis Braille which is full of fixed expressions.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
          {
            text: "To introduce the concept of Braille and a related story of Helen Keller, play",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/CRL-1-The%20Story%20of%20Hellen%20Keller.mp4",
            mediaType: TYPES.VIDEO,
            icon: "",
            mediaName: "The Story of Hellen Keller",
            timeTakenToComplete: "02:53",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading: "Read and discuss fixed expressions.",
    icon: WE_DO,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "To prepare students for The Story of Louis Braille, you can conduct the Warm Up (A and B) on ",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/SB-35-Pg.%2035.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 35",
            timeTakenToComplete: "",
          },
          {
            text: "Read The Story of Louis Braille, stopping after the second paragraph on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/SB-36-Pg.%2036.pdf",
            mediaType: TYPES.PDF,
            icon: "",
            mediaName: "Pg. 36",
            timeTakenToComplete: "",
          },
          {
            text: "Discuss the fixed expressions:",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
            dataList: [
              {
                text: "The world of thought and ideas was locked out to him.",
                media: "",
                mediaType: "",
                icon: "",
                mediaName: "",
                timeTakenToComplete: "",
              },
              {
                text: "To find the key to this door.",
                media: "",
                mediaType: "",
                icon: "",
                mediaName: "",
                timeTakenToComplete: "",
              },
              {
                text: "Not going to let his disability slow him down one bit.",
                media: "",
                mediaType: "",
                icon: "",
                mediaName: "",
                timeTakenToComplete: "",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Students will demonstrate their understanding of fixed expressions.",
    icon: YOU_DO,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Solve Words in Use (1-5) on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/SB-40-Pg.%2040.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 40",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, you can refer to",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Class5/English/Day%201/TR-2-Solution%20to%20Words%20in%20Use%201-5.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solution to Words in Use 1-5",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    render: `<ul><li>Complete Words in Use (1-5) on Pg. 40 of Chapter 4, if not finished.</li></ul>`,
    dataList: [],
  },
];

//SKG
export const PINNACLE_LITERACY_DAY1_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Literacy Coursebook and turn to Unit 1, page 1, 2 and 4",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Open the Literacy Workbook and turn to Unit 1, page 1, 2",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<div>Recognizes most frequently used letters and connects to corresponding sounds.</div>`,
    dataList: [],
  },
  {
    heading: "Circle Time",
    subHeading: "Recap letters of the alphabet though a classroom activity.",
    icon: CIRCLE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "Ask the students to loudly call out the letters from A to Z.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
          {
            text: "Play a game where you show the flashcard of any letter and the students whose surname begins with that letter, have to stand up.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Concept Time",
    subHeading: "Reinforce letter sequence through a song.",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Play the song once or twice",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/CRL-1-ABCD%20Rhyme.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "ABCD Rhyme",
            icon: "",
            timeTakenToComplete: "1:03",
          },
          {
            text: "Get students to complete the worksheet on Page 1 of the Literacy Coursebook.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/SR-1-Coursebook%20Pg.%201.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 1 ",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading: "Practise pre-writing strokes",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Complete the worksheet on pages 2 and 4 of the Coursebook.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/SR-2-Coursebook%20Pg.%202.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 2",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/SR-4-Coursebook%20Pg.%204.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 4",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Writing Time",
    subHeading: "Tracing and writing of letters from Aa to Zz.",
    icon: WRITING_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Complete the worksheet on pages 1 and 2 of the Workbook",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/WS-1-Workbook%20Pg.%201.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Workbook Pg. 1",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Literacy/Day%201/WS-2-Workbook%20Pg.%202.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Workbook Pg. 2",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    render: `<ul><li>Listen to ABCD Rhyme.</li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_NUMERACY_DAY2_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Numeracy Coursebook and turn to Unit 1, page 2, 3 and 5",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Open the Numeracy Workbook and turn to Unit 1, page 3 and 5",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<div>Counts objects with an understanding of cardinality to 50 accurately.</div>`,
    dataList: [],
  },
  {
    heading: "Circle Time",
    subHeading: "Recap numbers 1 to 20 through a song.",
    icon: CIRCLE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "Play the song and encourage the students to sing along. You may play the song twice",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/CRL-2-Numbers%201%20to%2020%20Song.mp4",
            mediaType: TYPES.VIDEO,
            icon: "",
            mediaName: "Numbers 1 to 20 songs",
            timeTakenToComplete: "2:23",
          },
        ],
      },
    ],
  },
  {
    heading: "Concept Time",
    subHeading:
      "Revise the missing numbers between 1 to 20 through an activity.",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Play the 'Missing Number' game.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Refer to the following resource for the steps",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/TR-5-Missing%20Numbers.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Missing Numbers",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading:
      "Practice missing numbers and before after and in between numbers through activities.",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "To revise the concept, you can",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Show the slides and play the ' Missing Numbers ' game.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/CRL-5-Missing%20Numbers.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Missing Numbers",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To reinforce the concept, you can show the slides and play the 'Before, After and Between' game.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/CRL-6-After%2C%20Before%2C%20In%20Between.pdf",
            mediaType: TYPES.PDF,
            mediaName: "After, Before, in Between",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Writing Time",
    subHeading:
      "Practice number sequences 1 to 20 through a poem and tracing numbers.",
    icon: WRITING_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Students can now read the poem on Pages 2 and 3 in the Coursebook and trace the numbers.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/SR-2-Coursebook%20Pg.%202.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 2",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/SR-3-Coursebook%20Pg.%203.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 3",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Students can now complete the worksheet on Page 5 of the Numeracy Workbook.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/Numeracy/Day%202/WS-5-Workbook%20Pg.%205.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Workbook Pg. 5",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    render: `<ul><li>Complete worksheets on Page 3 of the Numeracy Workbook and Page 5 of the Numeracy coursebook.</li></ul>`,
    dataList: [],
  },
];

export const PINNACLE_GENAWARENESS_DAY1_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the General Awareness Coursebook and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        type: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        type: "",
        media: "",
        mediaType: "",
        mediaName: "",
        timeTakenToComplete: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<div>Starts recognising ‘self’ as an individual belonging to a family and community.</div>`,
    dataList: [],
  },
  {
    heading: "Circle Time",
    subHeading: "Recognise the names of all students through a game.",
    icon: CIRCLE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "To encourage students to know their peers, you can play the Circle Roll game in a circle.",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        dataList: [
          {
            text: "Call a student's name and roll the ball to that student.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
          {
            text: "Then call out another student's name and have them roll the ball to that student.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
          {
            text: "Continue to play till the names of all students have been called out.",
            media: "",
            mediaType: "",
            icon: "",
            mediaName: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Concept Time",
    subHeading:
      "Identify different features of the body through a song and an activity.",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "To engage students, you can",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Play the song",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/General%20Awareness/Day%201/CRL-1-This%20is%20Me%20Song.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "This is Me Song",
            icon: "",
            timeTakenToComplete: "2:05",
          },
          {
            text: "Encourage the students to sing along and touch the body parts mentioned in the song.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
      {
        text: "To understand the differences in features in a fun and engaging manner, you can",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Play a game the Matching Features game",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Select a student and have them mention a distinctive feature about themselves.(e.g., brown hair).",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "All students with brown hair are to remain standing and others sit down.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Call out another feature and continue the game.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Consider features like hair colour, eye colour, and hairstyle (such as ponytail, braid, short, long, etc.).",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading: "Identify their own features by drawing their body.",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "10 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        icon: "",
        mediaName: "",
        dataList: [
          {
            text: "Students can now complete the worksheet on Page 1 of the General Awareness Coursebook",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/SKG/General%20Awareness/Day%201/SR-1-Coursebook%20Pg.%201.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 1",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOMEWORK,
    timeTakenToComplete: "",
    render: `<ul><li>Listen to This is Me Song.</li></ul>`,
    dataList: [],
  },
];

//PROPEL
//Class 2
export const PROPEL_EVS_DAY1_CH4 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Elixir G2 and turn to Chapter 4, page 33-35",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: `<ul><li>Describe the eating habits of different animals.</li></ul>`,
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Introduce the eating habits of animals using a video.",
    icon: I_DO,
    timeTakenToComplete: "25 Min",
    dataList: [
      {
        text: "This chapter will help us learn about the different types of animals and why we should take care of them.",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Let us begin by answering the questions given in the ‘Engage’ and ‘Explore’ sections on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/EVS/Day%201/SB-1-Pg.%2033.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 33",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Ask a few students to share their answers. Introduce to the class that different animals eat different kinds of food.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To explain the different eating habits of animals, show",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/EVS/Day%201/CRL-1-Animals%20and%20Their%20Food%20Habits.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Animals and Their Food Habits",
            icon: "",
            timeTakenToComplete: "4:41",
          },
          {
            text: "Then, read ‘Eating Habits of Animals’ from Pg. 34 and Pg. 35. After reading, ask the question under 'Think More'.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/EVS/Day%201/SB-16-Pg.%2034-35.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 34-35",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading:
      "Students independently answer questions from the textbook for conceptual clarity.",
    icon: WE_DO,
    timeTakenToComplete: "10 Min",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "We will now apply our learning by answering the following questions.",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Q 1 under ‘Subjective Questions’",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Q 1 under ‘Take a challenge’",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/EVS/Day%201/SB-17-Pg.%2043-44.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 43-44",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
      {
        text: "To check answers during notebook correction, use ",
        type: TYPES.UNORDERED_LIST,
        media:
          "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/EVS/Day%201/TR-1-Solution%20to%20Textbook%20Questions.pdf",
        mediaType: TYPES.PDF,
        mediaName: "Solutions to Textbook Questions",
        icon: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: CONCLUSION,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Today, we learned about the different eating habits of animals. In the next class, we will learn about domestic animals.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul><li>Q 1 (a, b, c) under ‘Evaluate’ on Pg. 38.</li>
    <li>Part (a) under ‘Objective  Questions’ on Pg. 43.</li></ul>`,
    dataList: [],
  },
];

export const PROPEL_MATH_DAY6_CH3 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Universal Math Prime G2 and turn to Chapter 3, page 42-43",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: "<ul><li>Add 3-digit numbers without or with regrouping.</li></ul>",
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading:
      "Explain how to add 3-digit numbers with regrouping using the place value table by playing a video.",
    icon: I_DO,
    timeTakenToComplete: "10 Min",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "In the previous class, students learned how to add 2-digit numbers using the place value table. Today, they will extend this understanding to 3-digit numbers.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To show the students how to add 3-digit numbers with regrouping using the place value table, play",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/Maths/Day%206/CRL-7-Adding%20Two%203-Digit%20Numbers%20with%20Regrouping.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Adding Two 3-Digit Numbers with Regrouping",
            icon: "",
            timeTakenToComplete: "2:43",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Practise solving problems involving addition of 3-digit numbers with regrouping.",
    icon: YOU_DO,
    timeTakenToComplete: "25 Min",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To practise concepts learned so far, solve Q 1 (a to f) from Innings 3.6 given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/Maths/Day%206/SB-10-Pg.%2042-43.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 42-43",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To check answers during notebook correction, use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/Maths/Day%206/TR-4-Solutions%20to%20Practice%20Questions.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solutions to Practice Questions",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: CONCLUSION,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Today, students learned to add 3-digit numbers with regrouping.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "In the next class, they will learn how to apply our understanding of addition to real-life situations.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render:
      "<ul><li>Solve Q 2 (a to f) of Innings 3.6 given on Pg. 42.</li></ul>",
    dataList: [],
  },
];

export const PROPEL_ENGLISH_CH3_DAY2 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the New English Carnival Class 2 Book and turn to Chapter 3, page 23",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: "<div>Read with fluency and intonation.</div>",
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading: "Reading the Story.",
    icon: I_DO,
    timeTakenToComplete: "30 Min",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Vocabulary Revision",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.HEADING,
          },
          {
            text: "Instruct students to tell what each word means using actions. ",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Show the presentation to revise new words.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/Maths/Day%206/CRL-7-Adding%20Two%203-Digit%20Numbers%20with%20Regrouping.mp4",
            mediaType: TYPES.PDF,
            mediaName: "New Words Revision",
            icon: "",
            timeTakenToComplete: "2:43",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Story Reading",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.HEADING,
          },
          {
            text: "Tell the students they are going to start reading the story 'The King of the Jungle'.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Show the video to introduce the story",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/English/Day%202/CRL-4-The%20King%20of%20the%20Jungle%20Animation.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "The King of The Jungle Animation",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Check for understanding",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.HEADING,
          },
          {
            text: "Cold call: Ask the given questions to check for understanding.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Where is the story happening? (The Jungle)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Who is there in the story? (The lion and the rabbit)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Reading the story with the teacher.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.HEADING,
          },
          {
            text: "Read the story from Pg 23 of the book or from the resource",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class2/English/Day%202/SB-23-Pg.%2023.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 23",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Instruct students to follow with their finger as you are reading and repeat after you.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Read each line in English, then explain in local language, then again read in English.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Check for understanding",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.HEADING,
          },
          {
            text: "Cold call: Ask the given questions to check for understanding.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "When did the lion hunt? (Night)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Whom did the lion see hopping by? (A rabbit)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Why could the rabbit not run away? Look at the third picture. (The lion was holding the rabbit.)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading: "Value Wheel",
    icon: WE_DO,
    timeTakenToComplete: "4 Min",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Turn and Talk: Instruct students to tell their partners what they would do if they were the rabbit. ",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Take responses if there is time.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: CONCLUSION,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Today we started reading the story 'The King of the Jungle.'",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Tomorrow we will finish reading the story and answer some questions.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul>
      <li>Read the story at home.</li>
      <li>Study for the spelling test. (mighty, hopping, idea, bowed, majesty, clever)</li>
      </ul>`,
    dataList: [],
  },
];

//Class 5
export const PROPEL_MATH_DAY2_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Universal Math Prime and turn to Chapter 1, page 5,6,8,9",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: "<ul><li>Build numbers beyond 9,99,999.</li></ul>",
    dataList: [],
  },
  {
    heading: "I Do",
    subHeading:
      "Explain the face value and place value of a digit in a number using a video.",
    icon: I_DO,
    timeTakenToComplete: "15 Mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "In the previous class, reading and writing large numbers was discussed. In this class, the place and face values of digits in such numbers will be discussed.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To explain the concepts of face value and place value of a number, play",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/CRL-3-Place%20Value%20and%20Face%20Value%20of%20Digits%20in%20a%20Number.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Place Value and Face Value of Digits in a Number",
            icon: "",
            timeTakenToComplete: "3:29",
          },
          {
            text: "To help check students' understanding of the concept, ask this question – What is the place value and face value of the 3 in 52,69,08,137? (Expected Student Response: Place value of 3 in 52,69,08,137 is 30 while its face value is 3.)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Ask students to read through example 3 given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/SB-2-Pg.%205-6.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 5-6",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "On the board, solve example 4 given on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/SB-2-Pg.%205-6.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 5-6",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Encourage students to solve the problem in their notebooks.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "You Do",
    subHeading:
      "Practise questions on finding the place value and face value of a digit in a number.",
    icon: YOU_DO,
    timeTakenToComplete: "20 Min",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "To practise concepts learned so far, solve Q 1 (a to f) from Innings 3.6 given on",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.UNORDERED_LIST,
            dataList: [
              {
                text: "Q 1 (a, b, c) from Innings 1.2 given on",
                media:
                  "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/SB-3-Pg.%208-9.pdf",
                mediaType: TYPES.PDF,
                mediaName: "Pg. 8-9",
                icon: "",
                timeTakenToComplete: "",
              },
              {
                text: "Solve",
                media:
                  "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/WS-1-Worksheet%201.pdf",
                mediaType: TYPES.PDF,
                mediaName: "Worksheet 1",
                icon: "",
                timeTakenToComplete: "",
              },
            ],
          },
          {
            text: "To check answers during notebook correction, use",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Maths/Day%202/TR-1-Solutions%20to%20Practice%20Questions.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Solutions to Practice Questions",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: CONCLUSION,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render:
      "<ul><li>In this class, students learned how to find the place value and face value of a digit in a given number. In the next class, students will learn to represent large numbers in expanded form and standard form.</li></ul>",
    dataList: [],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render:
      "<ul><li> Read the topic 'Face Value of a Digit in a Number' and 'Place Value of a Digit in a Number' given on Pg. 5.</li><li>Solve Q 1 (d, e) of Innings 1.2 given on Pg. 9.</li></ul > ",
    dataList: [],
  },
];

export const PROPEL_SCIENCE_DAY2_CH2 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Elixir Class 5 and turn to Chapter 2, page 15, 16",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "I Do",
    subHeading:
      "Teach the different parts of the brain and their functions using a video.",
    icon: I_DO,
    timeTakenToComplete: "15 Mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "In the last class, we learned about the nervous system and the importance of the brain. In this class, we will learn about the structure and functions of the brain.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Ask students to open their textbooks and answer the question given under the 'Engage' section on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Science/Day%202/SB-1-C5Ch2-Page-14.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 14",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Once the students have finished answering, ask them the following questions.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Which organ is controlling all these actions in our body? (Expected student response: The brain)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Are all these actions controlled by a single part of the brain? (Accept all relevant responses)",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "To teach the different parts of the brain and their functions, show",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Science/Day%202/CRL-4-C5Ch2-Parts-of-the-Brain.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Parts of the Brain",
            icon: "",
            timeTakenToComplete: "1:15",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "Summarise the functions of the different parts of the brain using",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Science/Day%202/CRP-1-C5Ch2-Parts-of-the-Brain.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Parts of the Brain",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
          {
            text: "To check for students' understanding, ask the question under the 'Think More' section on",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/Class5/Science/Day%202/SB-3-C5Ch2-Page-16.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Pg. 16",
            icon: "",
            timeTakenToComplete: "",
            type: TYPES.PARAGRAPH,
          },
        ],
      },
    ],
  },
  {
    heading: "We Do",
    subHeading: "Activity to make a model of the brain.",
    icon: WE_DO,
    timeTakenToComplete: "20 Min",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "Now that we know about the different parts of the brain, let us create a model of the brain to understand the different parts better.",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Divide the students into groups of 4 and distribute the clay.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Ask the students to observe the structure of the brain shown in the textbook and use their creativity to build their own clay models.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Appreciate the students for their efforts and creativity.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: CONCLUSION,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render:
      "<div>Today, we learned about the different parts of the brain and their functions. The different parts of the brain are the cerebrum, cerebellum, and medulla oblongata.</div>",
    dataList: [],
  },
  {
    heading: "Home practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    type: TYPES.UNORDERED_LIST,
    render: `<ul>
        <li>Answer Q 2 under the 'Subjective Questions' section on <strong>Pg.No. 25</strong>.</li>
        <li>Perform Activity 1 given on <strong>Pg.No. 16</strong>.</li>
      </ul>`,
    dataList: [],
  },
];

//SKG
export const PROPEL_CLL_DAY2_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Communication, Language, and Literacy SKG and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Communication, Language, and Literacy Workbook and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: "<div>Identify letter and beginning letter sounds</div>",
    dataList: [],
  },
  {
    heading: "Concept Time",
    subHeading: "",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Play",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/SKG/Literacy/Day%202/CRL-1-Alphabet%20Sound%20Song.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Alphabet Sound Song",
            icon: "",
            timeTakenToComplete: "4:39",
          },
          {
            text: "Sing along with the song.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Repeat the song and encourage students to sing along.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading: "",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "20 Mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Get the students to open",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/SKG/Literacy/Day%202/WS-1-Workbook%20Pg.%201.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Workbook Pg. 1",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Read the instructions aloud.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Move around and help those who need assistance.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Writing Time",
    subHeading: "",
    icon: WRITING_TIME,
    timeTakenToComplete: "20 Mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Get the students to open their notebooks.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Say a letter sound and ask them to write the letter in their notebook.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Repeat this 6-7 times.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
];

export const PROPEL_NUMERACY_DAY2_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Numeracy SKG and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Numeracy Coursebook and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render: "<div>Rote count from 1 - 10 in correct sequence</div>",
    dataList: [],
  },
  {
    heading: "Concept Time",
    subHeading: "",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "15 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Play the song number song and have students sing along.",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/SKG/Numeracy/Day%201/CRL-1-Ten%20Little%20Indians%20Song.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Ten Little Indians Songs",
            icon: "",
            timeTakenToComplete: "1:04",
          },
          {
            text: "Write numbers 1 to 10 on the board to revise how to write numbers in the correct sequence.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading: "",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "15 Mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Get the students to open",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/SKG/Numeracy/Day%201/SR-1-Coursebook%20Pg.%201.pdf",
            mediaType: TYPES.PDF,
            mediaName: "Coursebook Pg. 1",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Ask them to fill in the missing numbers.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Move around and help those who need assistance.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Writing Time",
    subHeading: "",
    icon: WRITING_TIME,
    timeTakenToComplete: "10 Mins",
    type: TYPES.UNORDERED_LIST,
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Get the students to open their notebooks.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Ask them to write numbers 1 to 10 in sequence.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
];

export const PROPEL_UNDERSTANDING_DAY4_CH1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Understanding our World SKG and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Understanding our World Coursebook and turn to Unit 1, page 1",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning outcome",
    subHeading: "View all learning outcomes",
    icon: LI_LO,
    timeTakenToComplete: "",
    render:
      "<div>Demonstrate understanding of basic concepts like parts of the body and senses.</div>",
    dataList: [],
  },
  {
    heading: "Concept Time",
    subHeading: "",
    icon: CONCEPT_TIME,
    timeTakenToComplete: "20 mins",
    dataList: [
      {
        text: "",
        type: TYPES.UNORDERED_LIST,
        media: "",
        mediaType: "",
        mediaName: "",
        icon: "",
        dataList: [
          {
            text: "Activity: Parts of Body",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
          {
            text: "Play the song",
            media:
              "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Propel/SKG/Understanding/Day%204/CRL-1-Body%20Parts%20Song.mp4",
            mediaType: TYPES.VIDEO,
            mediaName: "Body Parts Song",
            icon: "",
            timeTakenToComplete: "02:31",
          },
          {
            text: "Get the students to sing along. As they are singing get them to point at the body parts.",
            media: "",
            mediaType: "",
            mediaName: "",
            icon: "",
            timeTakenToComplete: "",
          },
        ],
      },
    ],
  },
  {
    heading: "Practice Time",
    subHeading: "",
    icon: PRACTICE_TIME,
    timeTakenToComplete: "20 Mins",
    render: `<div>
      <section>
        <div><strong>Activity: Simon Says</strong></div>
      </section>
      <section>
        <div><strong>Say:</strong> I am Simon.</div>
        <div>
          <ol>
            <li>When I say, 'Simon says, Blink your eyes' – everyone blinks.</li>
            <li>When I just say 'blink your eyes' – nobody blinks.</li>
            <li>If someone does an action without 'Simon says,' they're out.</li>
          </ol>
        </div>
      </section>
      <section>
        <div>Show how to play first. Try actions like pointing at the nose, touching ears, patting the head, shaking hands, and more. This game will help remember body parts.</div>
      </section>
    </div>`,
    dataList: [],
  },
  {
    heading: "Home Practice",
    subHeading: "",
    icon: HOME_PRACTICE,
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>Complete Page 1, 'My ID Card' in the Understanding Our World Coursebook.</li>
        </ul>`,
  },
];

//LEAD
//Class 2
export const LEAD_EVS_DAY3_UNIT1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the EVS Class 2 Student Reader and turn to Unit 1, page 12",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the EVS Class 2 Workbook and turn to Unit 1, page 6-7",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning Indicators",
    subHeading: "View all learning indicators",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>State the location of the brain.</li>
          <li>Explain the functions of the brain.</li>
          <li>Describe the look and feel of the brain.</li>
          <li>
            State one thing that went well after an activity, a project, or a
            unit and one thing that could. be done differently, with support.
          </li>
        </ul>`,
  },
  {
    heading: "Teacher Led",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "23 mins",
    dataList: [],
    render: `<div>
        <section>
          <div>
            <strong>Recap and Introduction: 8 minutes</strong>
          </div>
          <div>
            <strong>Ask:</strong>
          </div>
          <ol>
            <li>
              Name the four organs inside our body. (Expected student response:
              Brain, stomach, lungs, and heart)
            </li>
            <li>
              Which other parts do we have inside our body? (Expected student
              response: Bones and muscles)
            </li>
          </ol>
        </section>
        <section>
          <p>
            <strong>Ask:</strong> In this class, let us learn about one internal
            organ, the brain. Can you tell me where is brain present? (Expected
            student response: Inside our head)
          </p>
        </section>
        <section>
          <div>
            <strong>Say:</strong>
          </div>
          <ol>
            <li>
              (Touch your head while saying the line ahead) Touch your head and
              tell me if you feel something hard. (Take a few responses)
            </li>
            <li>
              This is because the brain is protected inside this hard, bony
              structure. It is known as the skull. (Show the flashcard for
              'brain' and 'skull'.)
            </li>
            <li>The skull is like a helmet, which keeps the brain safe.</li>
          </ol>
        </section>
         <section>
          <div>
            <strong>Popcorn Reading: 15 minutes</strong>
          </div>
          <div>
            <strong>Say:</strong> Let us learn about the functions of the brain.
          </div>
           <div>
            <strong>Do</strong>
          </div>
          <ul>
            <li>
             Ask students to open <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/EVS%20Unit%201%20Day%203/SR%203.pdf">[SR-3]</a> using the countdown routine.
            </li>
            <li>
              Read about 'Location', 'Look and Feel', and 'Functions of the Brain' on <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/EVS%20Unit%201%20Day%203/SR%203.pdf">[SR-3]</a> using the popcorn reading routine.
            </li>
            <li>After reading, explain how the brain looks and feels. Also, explain how the brain controls our body by sending messages to all parts of the body.</li>
             <li>
              After explaining about the brain, pass around one object of 1.3–1.5 kg in class in each row in 1 minute using the countdown routine.
            </li>
          </ul>
        </section>
        <section>
           <ol>
              <li>
                How does the brain look and feel? (Expected student response: It is soft and has many folds.)
              </li>
              <li>
                If we want to pick up a biscuit to eat, the brain sends the message to which part of the body? (Expected student response: Hands)
              </li>
          </ol>
        </section>
         <section>
          <div>
            <strong>Do: </strong> Tell students that they are now going to learn a song about the brain. Play <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/EVS%20Unit%201%20Day%203/CRL4.mp4">[CRL-4]</a>.  Let them listen to it for the first time. Play it one more time and sing along with the students.
          </div>
          <div>
            Point out to the students that CRL-4 can be seen on the Student App by scanning the QR code on SR-3 - Page No.12.
          </div>
           <div>
            <strong>Say:</strong>
          </div>
          <ul>
            <li>
             The brain helps us learn and remember things. It helps us think. It helps us perform activities such as running and dancing. It also helps us dream.
            </li>
            <li>
             Now that we have seen what the brain looks like, we will make a model of it.
            </li>
          </ul>
        </section>
      </div>;`,
  },
  {
    heading: "Group Practice",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "15 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Call out '1-2-3. . .eyes on me' and make sure every student is paying attention.</strong></div>
          <div>
            <strong>Activity Corner: 15 minutes</strong>
          </div>
          <div>
            <strong>Do:</strong>
          </div>
          <ol>
            <li>
              Divide the students into groups of five using the number-assign
              routine.
            </li>
            <li>
              Follow the steps from <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/EVS%20Unit%201%20Day%203/TR%202.mp4">[TR-2]</a> to make the brain
              model. Show each step and ask students to follow it. Ensure all
              the groups complete the task correctly.
            </li>
            <li>
              Tell them that the brain is soft like clay and has many folds
            </li>
            <li>
              After the model is made, ask students to answer the questions in
              the activity corner box given on <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/EVS%20Unit%201%20Day%203/WS%204.pdf">[WS-4]</a>.
            </li>
            <li>
              Read out each question and give students 30 seconds to write their
              answers.
            </li>
          </ol>
        </section>
      </div>`,
  },
];

export const LEAD_MATHS_DAY2_UNIT1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Math Class 2 Student Book and turn to Unit 1, page 11-12",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning Indicators",
    subHeading: "View all learning indicators",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>Count and write 3-digit numbers from 100 to 999.</li>
        </ul>`,
  },
  {
    heading: "Teacher Led",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "20 mins",
    dataList: [],
    render: `<div>
        <section>
          <div><strong>Call out '1, 2, 3. . . eyes on me' and start only when everyone is paying attention.</strong></div>
          <div>
            <strong>CRL Study and Discussion (15 minutes):</strong>
          </div>
          <p>In yesterday's class, we learned about representing 3-digit numbers using place value blocks. Let us learn more about numbers today.</p>
           <div>
            <strong>Ask:</strong>
          </div>
          <ol>
            <li>
              Can anyone help me count and recite numbers from 90? (Expected Student Response: 91, 92, 93, 94,. . .99)
            </li>
            <li>
              What comes after 99? (Expected Student Response: 100 — Students may or may not be able to answer this.
            </li>
          </ol>
        </section>
        <section>
          <p>
            <strong>Say: </strong> Today, we will learn how to count numbers after 100.
          </p>
        </section>
        <section>
          <div>
            Play <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Math%20Unit%201%20Day%202/CRL-3-C2U1%20Counting3digitno.mp4">[CRL-3]</a> to explain how to count from 100 to 999.
            <p>Point out to the students that CRL-3 can be seen on the Student App by scanning the QR code on SB-3 - Page No.12. </p>
          </div>
        </section>
         <section>
          <div>
            <strong>Check for Understanding (5 minutes):</strong>
          </div>
          <div>
            <strong>Say:</strong> Let us learn about the functions of the brain.
          </div>
          <div>
             Use the cold-call routine and <strong>ask</strong>:
          </div>
          <ul>
            <li>
             Can you count numbers from 101 to 120?
            </li>
            <li>
             Can you count numbers from 590 to 615?
            </li>
          </ul>
        </section>
      </div>;`,
  },
  {
    heading: "Group Practice",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "18 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div>
            <strong>Divide the students into groups of four. You may use the same groups as the ones made at the beginning of the unit.</strong>
          </div>
          <div>
            <strong>Using the countdown routine, get students to open:</strong> <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Math%20Unit%201%20Day%202/SB-4-C2U1.pdf">[SB-4]</a>
          </div>
           <div>
            <strong>Say:</strong>
          </div>
          <ul>
            <li>
             Open SB 4.
            </li>
            <li>
             Discuss with your partners on how to answer PQ 1.3
            </li>
            <li>
             Write the solutions in your notebook.
            </li>
            <li>
             You can use <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Math%20Unit%201%20Day%202/SB-2-C2U1.pdf">[SB-2]</a> and <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Math%20Unit%201%20Day%202/SB-3-C2U1.pdf">[SB-3]</a> for help.
            </li>
          </ul>

           <div>
            <strong>Do:</strong>
          </div>
          <ul>
            <li>
             Open SB 4.
            </li>
            <li>
              Move around and help the students who need support.
            </li>
            <li>
            After 10 minutes, discuss the answers with the students using <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Math%20Unit%201%20Day%202/SolvedSB-4-C2U1.pdf">[SolvedSB-4]</a>.
            </li>
          </ul>
        </section>
      </div>`,
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "2 mins",
    dataList: [],
    render: `<ul>
          <li>Say: In today's class, we learned how to count 3-digit numbers</li>
        </ul>`,
  },
  {
    heading: "Home Practice",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>Write numbers from 725 to 800 in your notebooks</li>
          <li>Answer PQ 1.2 on SB 4 of Unit 1.</li>
        </ul>`,
  },
];

//Class 5
export const LEAD_SCIENCE_DAY15_UNIT1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Science Class 5 Organ Systems and turn to Unit 1, page WS-12",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning Indicators",
    subHeading: "View all learning indicators",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <strong><li>Label the parts of the brain and describe their functions.</li></strong>
          <strong><li>Label the main parts of the nervous system.</li></strong>
        </ul>`,
  },
  {
    heading: "I Do(Teacher Led)",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "13 mins",
    dataList: [],
    render: `<div>
        <section>
          <div><strong>Introduction (3 minutes):</strong></div>
          <div><strong>Say:</strong> We have discussed two organ systems in this unit — the skeletal and the muscular systems. Today we will begin with another important organ system in our body..</div>
          <div>Write 'Nervous System' on the board.</div>
        </section>
        <section>
          <div><strong>CRL Study and Discussion (10 minutes)</strong></div>
          <div><strong>Ask:</strong></div>
          <ul>
            <li>Suppose you see that a mosquito is sitting on your hand. What do you do? (Expected student response: You move your hand so that the mosquito flies away and does not bite you.)</li>
            <li>How does that happen? (Accept all relevant answers.)</li>
          </ul>
        </section>
        <section>
          <div><strong>Say:</strong> Your skin sends a message of irritation, and your eyes send a message to your brain that it is a mosquito. Your brain remembers that the mosquito is dangerous, and it sends a message to your arm muscles to move your hand quickly.</div>
        <section>
        <section>
          <div><strong>Ask:</strong> In the example of the mosquito, you all heard that a message is sent to the brain. But did you wonder who receives the message? Who helps to pass the message from the brain to the muscle? (Take 1 or 2 responses)</div>
        <section>
        <section>
          <div><strong>Say: </strong>For messages to pass, the nervous system is made up of three main parts. Let us learn about it.</div>
          <div>To introduce the parts of the nervous system and explain the brain in detail, show  <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Science/Day%2015/CRL-14-C5U1-Nervous-System-and-Brain.pdf">[CRL-14]</a>.</div>
          <div>Ask the following questions to check for students' understanding: (Do not accept chorus answers.)</div>
          <ul>
            <li>What does the nervous system do? (Expected student response: The nervous system collects information from outside and sends messages to the body.)</li>
            <li>What are the different parts of the nervous system? (Expected student response: Brain, spinal cord, and nerves)</li>
            <li>What are the three parts of the brain? (Expected student response: Cerebrum, cerebellum, and medulla)</li>
          </ul>
        </section>
      </div>;`,
  },
  {
    heading: "We Do(Group Practice)",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "15 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Reading (5 minutes):</strong></div>
          <div><strong>Do: </strong>Divide the class into pairs using the number assign routine.</div>
          <div>Use the countdown routine to ask students to open <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Science/Day%2015/SR-9-C5U1.pdf">[SR-9]</a>.</div>
          <div><strong>Say: </strong>We will read the topic 'Parts of the Nervous System'. First, one student will read and the other student will finger-read. When I say switch, the other student will start reading and the first student will now finger-read.</div>
          <div>Get students to read and say switch after 2 minutes.</div>
        </section>
        <section>
          <div><strong>Activity (10 minutes):</strong></div>
          <div>Ask students to be ready with clay. Once, students are ready,</div>
          <div><strong>Say: </strong>You have to make a model of the brain. Conduct the activity by referring to <a href='https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Science/Day%2015/TR-11-C5U1-Brain-model-activity.pdf'>[TR-11]</a>.</div>
          <div><strong>Ask: </strong>How many parts does the brain have? (Expected student response: Three)</div>
          <div><strong>Say: </strong>The brain consists of the cerebrum, cerebellum, and medulla. You will have to label these parts in your model.</div>
          <div>Ask them to make labels for the parts of the brain using toothpicks and sticky notes. As students are making the model, move around and help the students who need assistance.</div>
        </section>
      </div>`,
  },
  {
    heading: "You Do (Individual Practice)",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "10 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Call out '1-2-3 . . . eyes on me' and make sure every student is paying attention.</strong></div>
          <div><strong>Say: </strong>Let us now answer some questions.</div>
          <div><strong>Do: </strong>Using the number assign routine, ask students to answer Q 3 given on <a href='https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Science/Day%2015/WS-12-C5U1.pdf'>[WS-12]</a>.</div>
          <div>In the last 3 minutes, discuss the answers using <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Science/Day%2015/SolvedWS-12-C5U1.pdf">[SolvedWS-12]</a>.</div>
        </section>
      </div>`,
  },
  {
    heading: "Conclusion",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "2 mins",
    dataList: [],
    render: `<div>
      <section>
        <div><strong>Say: </strong>We learned that the nervous system controls the movements of our entire body and the functions of the internal organs. It is made up of three main parts — the brain, the spinal cord, and the nerves. The three parts of the brain are cerebrum, cerebellum, and medulla.</div>
      </section>
    </div>`,
  },
  {
    heading: "Home Practice",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>Read 'Nervous System' on SR 9 of Unit 1.</li>
          <li>Answer Q 1 and Q 2 on WS 12 of Unit 1.</li>
          <li>Quiz on student app to answer a few questions on the nervous system.</li>
        </ul>`,
  },
];


export const LEAD_MATH_DAY2_UNIT1 = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Math Class 5 Student Book and turn to Unit 1, page 11-12",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    type: TYPES.LEARNING_INDICATOR,
    heading: "Learning Indicators",
    subHeading: "View all learning indicators",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<ul>
          <li>Find the common factors of two numbers.</li>
        </ul>`,
  },
  {
    heading: "Teacher Led",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "13 mins",
    dataList: [],
    render: `<div>
        <section>
          <div><strong>Recap (5 minutes):</strong></div>
          <div>
            <ul>
              <li><strong>Say:</strong> In the previous class, we recalled factors are all the numbers that divide a given number completely.</li>
              <li><strong>Ask: </strong>What are the factors of 18? (Expected Student Response: 1, 2, 3, 6, 9, 18)</li>
              <li><strong>Say: </strong>Open <a href='https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Maths/Day%202/SB-3.pdf'>[SB-3]</a> and discuss PQ 1.6 with your partner.  </li>
              <li><strong>Cold-call</strong> a few students and have them share their answers with the whole class.</li>
              <li><strong>Do: </strong>Solve the problem on board. Refer to <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Maths/Day%202/Solved%20SB-3.pdf">[SolvedSB-3]</a> for this.</li>
            </ul>
          </div>
        </section>
        <section>
          <div><strong>CRL Study and Discussion (10 minutes):</strong></div>
          <div>
            <ul>
              <li><strong>Say:</strong>In today's class, we will learn about common factors of two or more numbers.</li>
              <li>Play <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Maths/Day%202/CRL-3.mp4">[CRL-3]</a> to explain how to find the common factors of two numbers.</li>
              <li><strong>Do: </strong>Ask students to list factors of 6 and 12, and identify their common factors in their notebooks as shown in the CRL.</li>
            </ul>
          </div>
        </section>
        <div><strong>Check for Understanding (5 minutes):</strong></div>
        <section>
          <ul>
            <li><strong>Ask:</strong> In how many different ways were you able to arrange snacks on the plates? (Expected Student Response: We can arrange 1, 2, or 4 snacks on each plate.)</li>
            <li><strong>Ask:</strong> How can you find the answer to the above questions without using these items? (Expected Student Response: We can answer the above question by finding the factors of 12 and 8 and then identifying the common factors of the two numbers. The common factors will show the number of items that can be arranged on each plate.)</li>
            <li><strong>Do: Cold-call</strong> a few students and have them share how to find the common factors of 12 and 8.</li>
          </ul>
        </section>
      </div>`,
  },
  {
    heading: "Individual Practice",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "15 mins",
    dataList: [],
    render: ` <div>
        <div><strong>Activity (10 minutes):</strong></div>
        <section>
          <ul>
            <li><strong>Do:</strong> Divide the students into groups of 4. Distribute the resources to each group.</li>
            <li><strong></strong>Refer to <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/Class5%20/Maths/Day%202/TR-2.mp4">[TR-2]</a> to conduct this activity.</li>
            <li><strong>Write on the board:</strong> I have 12 biscuits and 8 sandwiches.</li>
            <li><strong>Say:</strong> I have 12 biscuits and 8 sandwiches. I want to put biscuits and sandwiches on separate plates. But each plate should have an equal number of snacks. In how many different ways can we arrange snacks on the plates?</li>
            <li><strong>Say:</strong> Work in groups. Use the counters to show the different ways in which we can arrange the snacks such that each plate has only one type of snack.</li>
            <li><strong></strong>Give the students 8 minutes to complete the activity.</li>
          </ul>
        </section>
        <div><strong>Check for Understanding (5 minutes):</strong></div>
        <section>
          <ul>
            <li><strong>Ask:</strong> In how many different ways were you able to arrange snacks on the plates? (Expected Student Response: We can arrange 1, 2, or 4 snacks on each plate.)</li>
            <li><strong>Ask:</strong> How can you find the answer to the above questions without using these items? (Expected Student Response: We can answer the above question by finding the factors of 12 and 8 and then identifying the common factors of the two numbers. The common factors will show the number of items that can be arranged on each plate.)</li>
            <li><strong>Do: Cold-call</strong> a few students and have them share how to find the common factors of 12 and 8.</li>
          </ul>
        </section>
      </div>`,
  },
];

//SKG
export const LEAD_INTCUR_DAY1_MR = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Student Reader Book and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Workbook and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Morning Routine",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "35 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Welcome: 10 minutes</strong></div>
          <div><strong>Do: </strong>Before class begins, play music (Good morning, Hokey pokey, Old Mac Donald, etc.)</div>
          <div>When students come, welcome them by putting a name tag on their chest using a safety pin and putting a sticker on their hand.</div>
          <div><strong>4 Corners: 10 minutes</strong></div>
          <div>Every morning, the classroom needs to be set with 4 learning corners. As students walk into class, let them choose which learning corner they want to go to first.</div>
          <div>Ensure that students rotate and go to other corners too. Spend 10 minutes every morning on this.</div>
          <div><strong>Note for the teacher:</strong> Let the students freely choose what they want to do. Ensure the students go to a corner as soon as they come to class without waiting for others. Observe students and make a note of their behaviour and what they follow.
          </div>
        </section>
        <section>
          <div>Music & Movement: 15 minutes</div>
          <div>
            <ol>
              <li> <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-21-v2.mp4">[SCR-21v2]</a>  <strong>— Good Morning Song</strong></li>
              <li> <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-24-v2.mp4">[SCR-24v2]</a>  <strong>— Days of the Week Song</strong></li>
            </ol>
          </div>
          <div><strong>Do: Play  <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-21-v2.mp4">[SCR-21v2]</a>   — Good Morning Song</strong> and sing along with the students and do actions as per <strong>SCR-37 (TR — Good Morning Song)</strong>.</div>
          <div>
            After 2–3 days of listening and dancing, encourage students to repeat the lyrics after you. You can put the video on mute and sing and get students to first sing after you and then sing with you. Ensure that you do actions and sing along with the students when the song is played.
          </div>
        </section>
        <section>
          <div><strong>Lyrics of the 'Good Morning' song: </strong></div>
          <div>
            <p>Good morning! Good morning!</p>
            <p>Hello, and how are you?</p>
            <p>Early in the morning,</p>
            <p>I say, ‘Good morning’</p>
            <p>Hello, and how are you?</p>
            <p>Good morning! Good morning!</p>
            <p>Hello, and how are you?</p>
            <p>Early in the morning,</p>
            <p>I say, ‘Good morning’</p>
            <p>Hello, and how are you?</p>
            <p>In the morning, I clap my hands</p>
            <p>In the morning, I do my dance</p>
            <p>In the morning, I shout, ‘Hurray!’</p>
            <p>This is going to be a wonderful day!</p>
          </div>
          <div><strong>Lyrics for 'Days of the Week' song:</strong></div>
          <div>
            <p>Monday, Tuesday,</p>
            <p>Wednesday, Thursday</p>
            <p>Friday, Saturday,
            </p>
            <p>Sunday
            </p>
            <p>The days of the week</p>
            <p>Now repeat after mother hen (repeat)</p>
            <p>Great job! now let's sing it quietly</p>
            <p>Monday, Tuesday,</p>
            <p>Wednesday, Thursday</p>
            <p>Friday, Saturday,</p>
            <p>Sunday</p>
            <p>The days of the week</p>
            <p>Well done! now let's try it really loud</p>
            <p>Monday, Tuesday,</p>
            <p>Wednesday, Thursday</p>
            <p>Friday, Saturday,</p>
            <p>Sunday</p>
            <p>The days of the week</p>
            <p>Fantastic! now let's sing it really fast</p>
            <p>Monday, Tuesday,</p>
            <p>Wednesday, Thursday</p>
            <p>Friday, Saturday,</p>
            <p>Sunday</p>
            <p>The days of the week (repeat twice)</p>
          </div>
        </section>
      </div>`,
  },
];

export const LEAD_INTCUR_DAY1_EEVS = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Student Reader Book and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Workbook and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Learning Indicators",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<div>
      <div>Early EVS: Interact with teacher and other children in class</div>
      <div>Early EVS: Show familiarity with classroom environment and routines</div>
      <div>Early EVS: Participate in class activities</div>
    </div>`,
  },
  {
    heading: "Morning Routine",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "45 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Activity 1: Know Each Other: 20 minutes </strong></div>
          <div><strong>Say: </strong>We enjoyed listening to the music. Now, let us know each other.</div>
          <div><strong>Do: </strong>Have all students sit in a circle. Call any student's name and roll the ball to that student. Then call out another student's name and have the first student roll the ball to them. As the ball rolls to the next student, sing the following lines: </div>
          <div>"I have a good friend, a good friend, a good friend,</div>
          <div>I have a good friend, and his/her name is (child's name)."</div>
          <div>Refer to <strong>SCR 41 (TR — Know Each Other)</strong> for the tune.</div>
          <div><strong>Activity 2: Name Your Seat: 15 minutes</strong></div>
          <div><strong>Do: </strong>Give students their name sheets along with crayons and star stickers. Ask them to decorate it with stickers, drawings, or colours. Once they are done, check their work to ensure all the labels are looking pretty and the students are happy with their labels.</div>
          <div>Then, ask students to stick their labels to their seats (table/chair/sitting mat). They will feel a sense of ownership of their place in the class. Let each student come and find their spot every day when they come to class. For the first few weeks, the teacher will have to help students identify their names. With enough practice, they will also start recognising their name in writing.</div>
          <div><strong>Activity 3: Classroom Rules: 10 minutes </strong></div>
          <div><strong>Do: </strong>Gather the students around you.</div>
          <div><strong>Ask: </strong>Do you have rules at home?</div>
          <div>Let students share some of the rules they follow at home. Accept 2–3 responses.</div>
          <div><strong>Say: </strong>Like home, we have some special class rules. These rules help us learn and have fun in school.</div>
          <div>Next, introduce the rules with <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-11-v3.pdf">[SCR-11v3]</a> <strong>(CRP —  Classroom Rules)</strong>. Do this as per the demo video  SCR 40 <strong>(TR — Classroom Rules)</strong> by reading the words, performing the actions, and explaining the rules in the local language. Ask students to repeat the rules.</div>
          <div><strong>Ask: </strong>"Do we all promise to follow these rules?" Ensure that the students promise to follow the rules. (At this point, do not tell them about what will happen if they don't follow rules. We do not want them to have any fear. Simply explain the rules and make them promise to follow them).
          </div>
          <div><strong>Do: </strong>For the next few days, every morning get students to repeat the class rules. Ask students to come forward and read the class rules to the rest. If a student breaks a rule, simply remind them by showing them the class rules and saying - "Can we also follow this rule _____?"</div>
        </section>
      </div>`,
  },
];

export const LEAD_INTCUR_DAY1_EELGA = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Student Reader Book and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Workbook and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Learning Indicators",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<div>
      <div>RC: Listen to picture story being read aloud by teacher and recognize common words</div>
      <div>Phonics: Recognize the beginning sound of a word (/a/ to /z/)</div>
      <div>Speaking: Speak sentences with few english words while presenting in class</div>
      <div>Speaking: Listen to nursery rhymes and sing along with it<div/>
      <div>Writing: Trace letters in upper and lowercase</div>
    </div>`,
  },
  {
    heading: "Reading",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "20 mins",
    dataList: [],
    render: ` <div>
      <section>
        <div><strong>Read Aloud: Squirrel Goes to School</strong></div>
        <div><strong>Do: </strong>Point and read the vocabulary words — 'school', 'home', 'friends', 'sun', 'tree', 'field' — from the vocabulary word wall. Ask students to repeat after you.</div>
        <div>Open the page with the story 'Squirrel Goes to School' in <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/TR-3.pdf">[TR-3]</a>  — <strong>SKG English Reader Part 1.</strong> Show the first page to students and follow the steps below for reading the story:</div>
        <div>
          <ol>
            <li>Read the title of the story and ask students to repeat it.</li>  
            <li>Then point out the author and read his/her name aloud. Ask students to repeat.</li>
          </ol>
        </div>
        <div><strong>Say: </strong>An author is a person who has written the story. Every story has a title and an author.</div>
        <div><ol><li>Read the story aloud to the students while showing them the pictures. Introduce the characters and elements in the story.</li></ol></div>
        <div>Translate the words in the local language if necessary.</div>
        <div><strong>Ask: </strong>Ask the following questions. Show the pictures of the story as responses.</div>
        <div>
          <ol>
            <li>Do you like coming to school? (Accept 2–3 responses from the students.)</li>
            <li>How are Tara and the squirrel related to each other? (Friends)</li>
            <li><p>Do you want to bring anyone along with you to the school? If yes, whom do you want to bring with you? (Accept 2–3 responses from the students.)</p>
            <p><strong>Say: </strong>I want to bring my pet dog/my doll to school. </p>
            </li>
            <li><p>What all do you see on your way to school? (Accept 2–3 responses from the students.)</p>
            <p><strong>Say: </strong>I see trees, dogs, buses on my way to school.</p>
            </li>
            <li>What do you like about your school? (Accept 2–3 responses from the students.)</li>
            <li>Whom do you like to meet in school? (Friends/teacher/didi/other relevant responses)</li>
          </ol>
        </div>
      </section>
      </div>`,
  },
  {
    heading: "Phonics",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "20 mins",
    dataList: [],
    render: ` <div>
      <section>
        <div><strong>Letter Sounds /a/, /b/, and /c/</strong></div>
        <div><strong>Do: </strong>Play <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/CRL-15.mp4">[CRL-15]</a>  (CRL — Alphabet Sounds song) the song.   ☞ Point out to the students that CRL-15 can be seen on the Student App by scanning the QR code on SR-1 - Page No.12. </div>
        <div><strong>Say: </strong>Shake hands with your partner and sing the song with them.</div>
        <div>Show <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-29-v2.mp4">[SCR-29v2]</a> (CRL — /a/, /b/, and /c/)  for letter sounds /a/, /b/, and /c/.</div>
        <div>Repeat the letters along with their sounds and the words that begin with them. Ask students to follow you.</div>
      </section>
      </div>`,
  },
  {
    heading: "Writing",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "20 mins",
    dataList: [],
    render: ` <div>
      <section>
        <div><strong>Trace Letters Worksheet</strong></div>
        <div><strong>Do: </strong>Ask students to open <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/WS-1.pdf">[WS-1]</a> in their workbooks.</div>
        <div>
          <ul>
            <li>Read the given instructions and ask students to trace and write the letters.</li>
            <li>Move around the class to check students' work and help them, if required.</li>
          </ul>
        </div>
      </section>
      </div>`,
  },
  {
    heading: "Speaking & Listening",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "30 mins",
    dataList: [],
    render: ` <div>
      <section>
        <div><strong>Show and Tell</strong></div>
        <div><strong>Purpose: </strong>To encourage speaking in English and give students an opportunity to bring their own learning to the class.</div>
        <div><strong>Do: </strong>List the students who are going to speak during the Show and Tell activity for this week.</div>
        <div><strong>Ask: </strong>Ask them to bring a toy/book/something that they have made or get them to narrate a story or an incident that is related to the story '﻿Squirrel Goes to School'. Tell them to bring something to the school, like Tara, in the story, brought the squirrel along with her.</div>
        <div>Ask each student to come to the front of the class and show what they brought. Ask them to say a few lines about it in English, using the following sentence starters. </div>
        <div>
          <ul>
            <li>This is my ______________.</li>
            <li>I like it because ______________.</li>
          </ul>
        </div>
        <div><strong>Say:</strong> While you are talking, if you need any help in translating a word, I will help you with it.</div>
        <div>Demonstrate how to speak during the show and tell using the <strong>SCR 56 (TR — Show and Tell)</strong> so that students can follow the same during the show and tell time.
        </div>
      </section>
      </div>`,
  },
];

export const LEAD_INTCUR_DAY1_EMATH = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Student Reader Book and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Workbook and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Learning Indicators",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<div>
      <div>- Match numerals with number names and quantity up to 10</div>
      <div> - Rote count from 1 – 50 in correct sequence</div>
    </div>`,
  },
  {
    heading: "Early Mathelogic",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "40 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div><strong>Activity 1: Number Line: 20 minutes</strong></div>
          <div><strong>Do: </strong>Draw a number line from 0 to 20 outside the class, as shown in <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/IMG-3.jpg">[IMG-3]</a>. Ask students to jump from 0 to 20 while counting out loud. Try different ways of jumping — hop, skip, jump with both feet, gallop, etc. Demonstrate the activity before students start.</div>
          <div><strong>Activity 2: Numbers 1 to 10 Activity: 20 minutes</strong></div>
          <div><strong>Do: </strong>Play <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/CRL-16.mp4">[CRL-16]</a> - 1,2 <strong>Buckle my shoe</strong> and sing along with the students.  ☞ Point out to the students that <strong>CRL-16</strong> can be seen on the Student App by scanning the QR code on <strong>SR-14 - Page No.25.</strong></div>
          <div><strong>Lyrics for the song 1,2 Buckle my shoe:</strong></div>
          <div>1,2 buckle my shoe</div>
          <div>3, 4 shut the door</div>
          <div>5,6 pick up the sticks</div>
          <div>7,8 lay them straight</div>
          <div>9,10 a big fat hen...a big fat hen.</div>
          <div>Once done, keep <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-1-V4.pdf">[SCR-1v4]</a> <strong>(CRP — Digit Cards)</strong>,  <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-2-v3.pdf">[SCR-2v3]</a>  <strong>(CRP — Dot Cards)</strong>, and  <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/SCR-3-V3.pdf">[SCR-3v3]</a>  <strong>(CRP — Number Name Cards)</strong>  from 1-10 with you. Follow the steps mentioned below to recap the numbers:</div>
          <div><ul>
            <li>Show digit cards from 1 to 10 in random order and ask students to say the number.</li>
            <li>Show dot cards from 1 to 10, and ask students to count the dots and say the number.</li>
            <li>Show number name cards from 1 to 10 and ask students to say the number.</li>
          </ul></div>
        </section>
      </div>`,
  },
];

export const LEAD_INTCUR_DAY1_PY = [
  {
    heading: "How To Use",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [
      {
        text: "Open the Student Reader Book and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Open the Workbook and turn to Unit 1, page 25",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
      {
        text: "Follow the lesson plan and use the resources",
        icon: CHECKED_ICON,
        media: "",
        mediaType: "",
        mediaName: "",
        type: "",
        dataList: [],
      },
    ],
  },
  {
    heading: "Learning Indicators",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "",
    dataList: [],
    render: `<div>
    - Physical: Participates in different physical activities
    </div>`,
  },
  {
    heading: "Physical & Yoga",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "23 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div>
            <ul>
              <li><strong>Aim the Ball</strong></li>
              <li><strong>Do: </strong>Keep the basket/bucket against the wall. Mark a line with chalk, approximately 6 to 8 feet away from the basket/bucket and call it the 'starting line'. Refer to <a href="https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SKG/Day%201/IMG-4.jpg">[IMG-4]</a> to set up this activity.</li>
              <li><strong>Say: </strong>Now we will play the 'Aim the Ball' game. You will have to stand at the start line and aim the ball at the basket/bucket and throw into it. Demonstrate the activity before conducting it.</li>
            </ul>
          </div>
        </section>
      </div>`,
  },
  {
    heading: "iHomework",
    subHeading: "",
    icon: "",
    timeTakenToComplete: "23 mins",
    dataList: [],
    render: ` <div>
        <section>
          <div>
            <ul>
              <li>Write the letters a, b, and c in your English notebook.</li>
              <li>Read each number and its number name on SR 14 in Student Reader. Then, count the stars.</li>
            </ul>
          </div>
        </section>
      </div>`,
  },
];
